import { Row, Col, Pagination } from 'antd';
import { LabworkOutput, LabworkListSort, LabworkStatus } from 'gql/types';
import {
  useSort,
  useHighlightElement,
  useScrollToElement,
} from 'modules/common/hooks';
import LabworkCard from 'modules/donor/components/LabworkCard';
import { LabworkCardListSorter } from 'modules/donor/components/LabworkCardList/LabworkCardListSorter';
import { usePagination } from 'modules/navigation/hooks/usePagination';
import { FC } from 'react';

import styles from './styles.module.scss';

const useLabworkListSort = () => useSort<LabworkListSort>();

type Props = {
  labworks: LabworkOutput[];
  updateLabworkHandler: (data: LabworkOutput) => void;
  updateLabworkStatusHandler: (id: string, status: LabworkStatus) => void;
  pagination: ReturnType<typeof usePagination>;
  sort: ReturnType<typeof useLabworkListSort>;
};
const LabworkCardList: FC<Props> = ({
  labworks,
  pagination,
  sort,
  ...otherProps
}) => {
  const isDataReady = labworks?.length > 0;

  const { urlId, activeHighlightId } = useHighlightElement({
    isReady: isDataReady,
  });

  useScrollToElement({
    isReady: isDataReady,
    selector: urlId ? `[id="labwork-card-${urlId}"]` : null,
  });

  return (
    <Row gutter={[0, 30]}>
      <Col className={styles.sorterWrapper}>
        <LabworkCardListSorter sort={sort} />
      </Col>
      <Col span={24}>
        <Row gutter={[0, 20]}>
          {labworks?.map((labwork) => (
            <Col span={24} key={labwork.id} id={`labwork-card-${labwork.id}`}>
              <LabworkCard
                {...otherProps}
                labwork={labwork}
                className={
                  labwork.id === activeHighlightId
                    ? styles.highlightedCard
                    : styles.defaultCard
                }
              />
            </Col>
          ))}
        </Row>
      </Col>
      <Col span={24}>
        <Pagination {...pagination.config} />
      </Col>
    </Row>
  );
};

export default LabworkCardList;
